import FrogBotIcon from 'assets/icons/frogBotIcon.svg'

export default FrogBotIcon
